module.exports = __webpack_public_path__ + "img/1 (118).3ed6ebf5.png";